import styled from 'styled-components'

export const LogoImg = styled.img`
    width: 100px;
    margin-left: 65%;
`
